import { ChevronDownIcon, ChevronUpIcon, LoadSpinner } from '@calizahq/react-components-v2'
import clsx from 'clsx'
import React, { ReactNode, useState } from 'react'

interface CardProps {
  cardClassName?: string
  children: JSX.Element | ReactNode
  header?: JSX.Element
  headerText?: string
  hideToStart?: boolean
  isLoading?: boolean
  minimizable?: boolean
  onClick?: () => void
}

export function Card({
  hideToStart = false,
  headerText,
  header,
  children,
  cardClassName = '',
  minimizable,
  onClick,
  isLoading = false,
}: CardProps) {
  const [minimize, setMinimize] = useState(hideToStart)

  return (
    <div
      className={clsx(
        'flex w-full flex-col overflow-hidden rounded-lg border shadow-lg border-secondary',
        onClick && 'cursor-pointer',
        cardClassName,
      )}
      onClick={onClick}
      onKeyDown={() => {}}
      role="presentation"
    >
      {header ? (
        <div className="flex items-center justify-between border-b p-3 bg-emphasis border-secondary">{header}</div>
      ) : (
        <div
          className={`items-center justify-between border-b p-3 bg-emphasis border-secondary ${
            headerText ? 'flex' : 'hidden'
          } `}
          onClick={() => {
            minimizable && setMinimize(!minimize)
          }}
          role="presentation"
        >
          <p className="font-bold text-p-sm leading-120">{headerText}</p>

          {minimizable && (
            <>
              {minimize ? (
                <ChevronDownIcon className="w-5 cursor-pointer icon-tertiary" />
              ) : (
                <ChevronUpIcon className="w-5 cursor-pointer icon-tertiary" />
              )}
            </>
          )}
        </div>
      )}
      <>
        {minimize ? (
          <button className="w-full py-4 text-center text-sm text-action-primary" onClick={() => setMinimize(false)}>
            View
          </button>
        ) : (
          <>
            {isLoading ? (
              <div className="flex h-48 w-full items-center justify-center">
                <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
              </div>
            ) : (
              <>{children} </>
            )}
          </>
        )}
      </>
    </div>
  )
}
